import React from "react";
import { Box, Tooltip, Typography, alpha, useTheme } from "@mui/material";
import { groupReactions } from "../utils/teamMessageUtils";

const TeamMessageReactions = ({
  reactions = [],
  currentUserId,
  onToggle,
  disabled = false,
  isOwn = false,
}) => {
  const theme = useTheme();
  const grouped = groupReactions(reactions);
  if (!grouped.length) return null;

  const pillBg = (mine) =>
    mine
      ? alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.22 : 0.1)
      : theme.palette.mode === "dark"
        ? alpha(theme.palette.common.white, 0.1)
        : alpha(theme.palette.common.black, 0.05);

  const pillSx = (mine) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 0.25,
    height: 20,
    px: 0.5,
    borderRadius: 6,
    bgcolor: pillBg(mine),
    border: "none",
    boxShadow: "none",
    cursor: disabled ? "default" : "pointer",
    transition: "background-color 0.12s ease",
    font: "inherit",
    outline: "none",
    "&:hover": disabled
      ? {}
      : {
          bgcolor: mine
            ? alpha(theme.palette.primary.main, theme.palette.mode === "dark" ? 0.3 : 0.14)
            : alpha(theme.palette.common.black, theme.palette.mode === "dark" ? 0.14 : 0.08),
        },
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 0.35,
        mt: 0.4,
        maxWidth: "100%",
        justifyContent: isOwn ? "flex-end" : "flex-start",
        pl: isOwn ? 0 : 0.25,
        pr: isOwn ? 0.25 : 0,
      }}
    >
      {grouped.map(({ emoji, users, count }) => {
        const mine = users.some((u) => String(u.userId) === String(currentUserId));
        const names = users.map((u) => u.userName || `#${u.userId}`).join(", ");
        return (
          <Tooltip key={emoji} title={names || emoji} placement="top">
            <Box
              component="button"
              type="button"
              disabled={disabled}
              onClick={disabled ? undefined : () => onToggle?.(emoji)}
              sx={pillSx(mine)}
              aria-label={`${emoji} ${count}`}
            >
              <Typography
                component="span"
                sx={{
                  fontSize: "1rem",
                  lineHeight: 1,
                  opacity: 1,
                  fontFamily:
                    '"Segoe UI Emoji", "Apple Color Emoji", "Noto Color Emoji", sans-serif',
                }}
              >
                {emoji}
              </Typography>
              {count > 1 ? (
                <Typography
                  component="span"
                  sx={{
                    fontSize: "0.625rem",
                    fontWeight: 600,
                    color: "text.secondary",
                    lineHeight: 1,
                    ml: 0.15,
                  }}
                >
                  {count}
                </Typography>
              ) : null}
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default TeamMessageReactions;
